import { SectionHeader, NavButtons, Badge, ScanButton, ImagingSection } from "@/components/workflow/ui";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { FlaskConical } from "lucide-react";

export default function StepInvestigations({ investigations, reports, setReports, imaging, setImaging, onBack, onNext }) {
  return (
    <div data-testid="investigations-section">
      <SectionHeader icon={FlaskConical} sub="Step 6 · Investigations" title="Ordered investigations" />
      {investigations.rationale && <p className="text-sm text-zinc-600 -mt-2 mb-6">{investigations.rationale}</p>}
      <div className="space-y-px bg-zinc-200 border border-zinc-200 rounded-md overflow-hidden">
        {investigations.investigations?.map((t, i) => (
          <div key={t.test || i} className="bg-white p-5">
            <div className="flex items-center gap-2 flex-wrap">
              <h3 className="font-medium text-zinc-900">{t.test}</h3>
              <Badge className="bg-blue-50 text-[#002FA7] border-blue-200">{t.category}</Badge>
            </div>
            <p className="mt-1 text-sm text-zinc-500">{t.purpose} {t.targets_differential && `· targets ${t.targets_differential}`}</p>
            <div className="mt-3 space-y-1.5">
              <div className="flex items-center justify-between">
                <Label className="text-xs">Result <span className="text-zinc-400">(optional)</span> — type it, or scan the written / printed report</Label>
                <ScanButton index={i} onText={(txt) =>
                  setReports((r) => r.map((row, j) => (j === i ? { ...row, result: (row.result ? row.result + "\n" : "") + txt } : row)))
                } />
              </div>
              <Textarea
                rows={2}
                data-testid={`report-${i}`}
                value={reports[i]?.result || ""}
                onChange={(e) => setReports((r) => r.map((row, j) => (j === i ? { ...row, result: e.target.value } : row)))}
                placeholder="e.g. Troponin 0.9 ng/mL (elevated) — or scan the lab report image/PDF"
              />
            </div>
          </div>
        ))}
      </div>
      <p className="mt-2 text-xs text-zinc-400">Entering results sharpens the final diagnosis, but they are optional — you can proceed without them.</p>
      <ImagingSection imaging={imaging} setImaging={setImaging} />
      <NavButtons onBack={onBack} onNext={onNext} nextLabel="Submit reports → Final diagnosis" nextTestId="submit-reports-btn" />
    </div>
  );
}
